mutation StopGiveaway($giveawayId: ID!) {
  giveaway: StreamToolsStopGiveaway(giveawayId: $giveawayId) {
    giveawayId
    status
    entrantCount
    hasDraw
    startedAt
    closedAt
    publishedAt
    version
    winners {
      login
      displayName
      rank
      kind
    }
  }
}
